const Consts = {
	AWS_URL: "https://nid-de-poule.s3.eu-west-3.amazonaws.com/"
}

export default Consts;
